import React, { useState } from 'react';
import FileDownload from './FileDownload';
import PrintFile from './PrintFile';
import MenuIcon from '../../../GridView/MenuIcon';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';
import { FileSharingClientDetailsModal } from 'components/FileSharing/FileSharingClientDetailsModal';
import SummarizeFile from './SummarizeFile';
import CreateCourtEvent from './CreateCourtEvent';
import GlobalTooltip from 'components/GlobalTooltip';
import useFileDownload from 'modules/file_manager/hooks/useFileDownload';
import { useUserDetailsContext } from 'context/userDetailsContext';

function ActionsTemplate({ rowData, e, itemsRef, onDownloadComplete }) {
  const { isClientFileManager } = useFileManagerContext();
  const { downloadCertFile } = useFileDownload();
  const { checkSubPermission } = useUserDetailsContext();

  const docTypeVal = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  const printFileFormats = ['image/png', 'application/pdf', docTypeVal];
  const fileFormatsForSummary = ['application/pdf', 'docx', 'application/msword', docTypeVal];

  const [clientDetailsModalshow, setClientDetailsModalshow] = useState(false);

  const handleDownloadCertificate = () => {
    downloadCertFile(rowData, onDownloadComplete);
  };

  return (
    <React.Fragment key={e.rowIndex}>
      <FileSharingClientDetailsModal
        show={clientDetailsModalshow}
        setShow={setClientDetailsModalshow}
        onHide={() => {
          setClientDetailsModalshow(false);
        }}
        rowData={rowData}
      />
      <span className="p-column-title text-break">Actions</span>
      <span className="text-break relative d-flex align-items-center justify-content-end">
        {rowData.entry_type !== 'folder' && (
          <>
            {checkSubPermission('ai_court_setting_notice') && !isClientFileManager && rowData?.is_court_setting_notice && (
              <CreateCourtEvent rowData={rowData} />
            )}
            {!isClientFileManager &&
            rowData?.file_type &&
            fileFormatsForSummary.includes(rowData?.file_type?.toLowerCase()) &&
            checkSubPermission('ai_summarize')
              ? rowData?.token_count && Number(rowData?.token_count) < 100000 && <SummarizeFile rowData={rowData} />
              : null}
            {checkSubPermission('file_sharing_non_lawft') && !isClientFileManager && (
              <span role="button" onClick={() => setClientDetailsModalshow(true)}>
                <GlobalTooltip tooltip="Generate Link" className="me-3 text-primary-main">
                  <i className="bi bi-link-45deg" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            )}

            {!isClientFileManager && rowData && rowData.esignature_status && rowData.esignature_status.toUpperCase() === 'SIGNED' && (
              <span role="button" onClick={handleDownloadCertificate}>
                <GlobalTooltip tooltip="Download Sign Certificate" className="me-3 text-primary-main">
                  <i className="bi bi-box-arrow-down text-primary-main" aria-hidden="true" />
                </GlobalTooltip>
              </span>
            )}
            {rowData?.file_type && printFileFormats?.includes(rowData?.file_type?.toLowerCase()) ? <PrintFile rowData={rowData} /> : null}

            <FileDownload rowData={rowData} onDownloadComplete={onDownloadComplete} />
          </>
        )}

        {!isClientFileManager ? (
          <MenuIcon item={rowData} index={e.rowIndex} itemsRef={itemsRef} onDownloadComplete={onDownloadComplete} />
        ) : null}
      </span>
    </React.Fragment>
  );
}

export default ActionsTemplate;
